import type { Connector } from '@avalara/types/index';
import type { ChangeEvent } from 'react';

// TODO: Refactor this function.
export const onSearch = (
  e: ChangeEvent,
  onSearchConnectors: (arg0: Array<Connector>, arg1: string, arg2: string) => void,
  searchString: string,
  connectors: Array<Connector>,
) => {
  const target = e.target as HTMLInputElement;
  const targetValue = target.value;
  if (targetValue.length > 1) {
    const resultSet = connectors
      .filter((connector) => connector.name.toLowerCase().indexOf(targetValue.toLowerCase()) !== -1)
      .filter((c) => c.id !== 'a0n0b00000ODPh2AAH');
    onSearchConnectors(resultSet, targetValue, searchString);
  } else {
    onSearchConnectors([], targetValue, searchString);
  }
};

export const generateGridView = (connectors: Array<Connector>, connectorList: Array<string>): Array<Connector> => {
  const gridView: Array<Connector> = [];
  const filteredConnectors = connectors.filter((c) => connectorList.includes(c.id));
  for (const connector of filteredConnectors) {
    // avoid duplicates
    if (!gridView.some((gridViewConnector) => gridViewConnector.id === connector.id)) {
      const copiedConnector = { ...connector };

      if (connector.logo == null) copiedConnector.logo = '/assets/images/avalara_logo.png';

      gridView.push(copiedConnector);
    }
  }
  return gridView;
};
